// import Vue from "vue";
// import carousel from "vue-owl-carousel2";

// Vue.component("owl-carousel", carousel);

import Vue from "vue";

import VueCarousel from "vue-carousel";

Vue.use(VueCarousel);
